module.exports = __webpack_public_path__ + "img/Search.99b62f7f.svg";